<script setup lang="ts">
  import { BottomSheet, Typo, TypoVariant } from '@travelata-libs/ui-kit';
  import { setBodyOverflow } from '@travelata-libs/utils';
  import { nextTick, ref } from 'vue';
  import { useMobileSearchFlowContext } from '../../../model/useMobileSearchFlow';

  const flow = useMobileSearchFlowContext();

  const SHEET_Z_INDEX = 1200;

  const bottomSheetRef = ref<null | { close: () => Promise<void> }>(null);

  const onSelect = async (age: number): Promise<void> => {
    flow.applyChildAge(age);
    await bottomSheetRef.value?.close();
    flow.closeAgePicker();
    setBodyOverflow('hidden');
  };
  const onClose = async () => {
    flow.closeAgePicker();
    await nextTick();
    setBodyOverflow('hidden');
  };
</script>

<template>
  <BottomSheet
    ref="bottomSheetRef"
    root-class="mobile-child-age-sheet"
    :z-index="SHEET_Z_INDEX"
    :animated="true"
    :icon-closable="true"
    @close="onClose"
  >
    <template #header>
      <Typo
        class="mobile-child-age-sheet__typo"
        :variant="TypoVariant.Heading5"
        tag="span"
      >
        {{ flow.texts.labels.childAge }}
      </Typo>
    </template>

    <div
      class="mobile-child-age-sheet__body"
      data-testid="search-form-mobile-child-age"
      @touchmove.stop
    >
      <Typo
        class="mobile-child-age-sheet__hint"
        variant="body-m-400"
        tag="p"
      >
        {{ flow.texts.childAgeHint }}
      </Typo>

      <ul class="mobile-child-age-sheet__list">
        <li
          v-for="option in flow.childAgeOptions"
          :key="option.value"
          class="mobile-child-age-sheet__item"
        >
          <button
            type="button"
            class="mobile-child-age-sheet__option"
            :data-testid="`search-form-mobile-child-age-${option.value}`"
            @click="onSelect(option.value)"
          >
            <Typo
              :variant="TypoVariant.BodyLRegular"
              tag="span"
            >
              {{ option.label }}
            </Typo>
          </button>
        </li>
      </ul>
    </div>
  </BottomSheet>
</template>

<style scoped lang="scss">
  .mobile-child-age-sheet {
    &__typo {
      padding-top: var(--spacing-xxs);
      text-align: center;
      width: 100%;
    }

    &__body {
      box-sizing: border-box;
      display: flex;
      flex-direction: column;
      gap: var(--spacing-xs);
      width: 100%;
    }

    &__hint {
      color: var(--color-text-primary);
      margin: 0;
    }

    &__list {
      display: flex;
      flex-direction: column;
      list-style: none;
      margin: 0;
      padding: 0;
    }

    &__option {
      align-items: center;
      background: none;
      border: none;
      color: var(--color-text-primary);
      cursor: pointer;
      display: flex;
      justify-content: space-between;
      padding: var(--spacing-s) 0;
      text-align: left;
      width: 100%;
    }
  }
</style>
